<template>
  <v-container>
    <v-card class="elevation-2 mx-auto" :loading="loading" max-width="600">
      <v-card-title>Add Object</v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <form>
          <v-row>
            <v-col cols="12" md="12" sm="12" class="py-0">
              <v-select
                v-model="form_data.position_id"
                :error-messages="form_error.position_id"
                :items="positions"
                @change="getType(form_data.position_id)"
                item-text="title"
                item-value="vo_position_id"
                label="Object Position"
                outlined
                dense
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12" sm="12" class="py-0">
              <v-file-input
                v-model="form_data.object_file"
                :error-messages="form_error.object_file"
                accept="image/*, video/*"
                placeholder="Select File"
                prepend-icon="mdi-file"
                outlined
                dense
                v-show="show_file"
              ></v-file-input>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12" sm="12" class="py-0">
              <v-text-field
                v-model="form_data.link"
                :error-messages="form_error.link"
                dense
                label="Link"
                outlined
                v-if="!show_contact_details"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12" sm="12" class="py-0">
              <v-textarea
                v-model="form_data.contact_details"
                :error-messages="form_error.contact_details"
                dense
                rows="3"
                label="Contact Details"
                outlined
                v-if="show_contact_details"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-btn
            class="mr-4"
            color="secondary"
            @click="addObject"
            :loading="loading"
            :disabled="loading"
          >submit</v-btn>
        </form>
      </v-card-text>
    </v-card>
    <v-btn small color="secondary" fixed fab bottom left :to="'/vendor/details/'+form_data.vendor_id">
      <v-icon>mdi-arrow-left</v-icon>
    </v-btn>
  </v-container>
</template>
<script>
import { mapMutations } from "vuex";
export default {
  name: "AddVendor",
  data() {
    return {
      positions: [],
      form_data: {
        vendor_id:null
      },
      form_error: {},
      loading: false,
      data: {},
      show_file : false,
      show_contact_details : false,
    };
  },
  methods: {
    ...mapMutations("utils", ["setAlert"]),
    addObject() {
      let _self = this;
      this.loading = "secondary";
      let serverData = JSON.parse(JSON.stringify(this._data.form_data));
      let formData = new FormData();
      for (let key in serverData) {
        formData.append(key, serverData[key]);
      }
      if (this.form_data.object_file) {
        formData.append("object_file", this.form_data.object_file);
      }
      formData.append("is_social", !this.show_file);
      formData.append("is_contact_details", this.show_contact_details);
      this.$axios.post(`admin/vendor/object/add`, formData)
        .then((response) => {
          _self.form_error = {};
          let response_data = response.data;
          if (response_data.status) {
            _self.setAlert({
              show: true,
              variant: "success",
              message: response.data.message,
              dismissCountDown: 5000,
            });
            this.user_data = response_data.user_data;
            _self.$router.push("/vendor/details/"+_self.form_data.vendor_id);
          } else {
            let errors = response_data.error;
            for (let key in errors) {
              _self.form_error[errors[key].field] = errors[key].message;
            }
          }
          _self.loading = false;
        })
        .catch((e) => {
          console.log(e);
          _self.loading = false;
        });
    },
    getPositionList() {
      let _self = this;
      this.$axios.get(`admin/vendor/position_list?vendor_id=`+this.$route.params.vendor_id)
        .then((response) => {
          let response_data = response.data;
          if (response_data.status) {
            _self.positions = response_data.data;
          }
          _self.loading = false;
        })
        .catch((e) => {
          console.log(e);
          _self.loading = false;
        });
    },
    getType(position_id){
      var result = this.positions.filter(obj => {
        return obj.vo_position_id === position_id
      })
      this.show_file = (result[0].type=='CONTACT')?false:true;
      this.show_contact_details = (result[0].type=='CONTACT')?true:false;
    }
  },
  mounted: function () {
    this.form_data.vendor_id = this.$route.params.vendor_id
    this.getPositionList();
  },
};
</script>